import React, { memo, useMemo } from 'react'
import { Modal } from '@mui/material'
import tw from 'twin.macro'
import { ModalHeader } from 'src/components/shared/ModalHeader'
import { GridRowSelectionModel } from '@mui/x-data-grid-pro'
import { ApproveSubcontractorRequestsForm } from './approve-subcontractor-requests-form/ApproveSubcontractorRequestsForm'
import { addS } from 'src/utils/baseUtils'

interface Props {
  isOpen: boolean
  subcontractorRequestsSelection?: string[] | GridRowSelectionModel
  onClose(): void
  onSubmit(): void
}

const ApproveSubcontractorRequestsModalComponent = ({
  isOpen,
  subcontractorRequestsSelection,
  onClose,
  onSubmit,
}: Props) => {
  const container = useMemo(() => document.getElementById('root'), [])

  return (
    <Modal
      container={container}
      open={Boolean(isOpen)}
      onClose={onClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
      css={tw`flex justify-center items-center backdrop-blur`}
    >
      <div css={tw`bg-white rounded-lg w-[340px]`}>
        <ModalHeader
          title={`Approve ${addS(
            subcontractorRequestsSelection ? subcontractorRequestsSelection.length : 1,
            'contractor',
          )}`}
          onClose={onClose}
        />
        <ApproveSubcontractorRequestsForm
          onClose={onSubmit}
          subcontractorRequestsSelection={subcontractorRequestsSelection}
        />
      </div>
    </Modal>
  )
}

export const ApproveSubcontractorRequestsModal = memo(ApproveSubcontractorRequestsModalComponent)
